module.exports = __webpack_public_path__ + "img/wilson-pro.dfe11353.jpg";